export default "__VITE_ASSET__CGeNM7_Z__"